module.exports = __webpack_public_path__ + "static/media/cieana.8398a736.jpeg";